import classNames from "classnames";
import { memo } from "react";
import { RedoToggle } from "../arbiter-components/toggle/redo-toggle";
import { Flex } from "../flex";
import { SettingsRowLabel, type SettingsRowBadge } from "./settings-row-label";
import * as css from "./settings-rows.module.css";

/** Row with a switch. */
export const SettingsToggleRow = memo(function SettingsToggleRow({
  title,
  description,
  badge,
  value,
  setValue,
  disabled,
  indeterminate,
  semantic,
  testId,
}: {
  title: string;
  description?: string;
  badge?: SettingsRowBadge;
  value: boolean;
  setValue(value: boolean): void;
  disabled?: string | boolean;
  /** Mixed state. The stored value stays a boolean. */
  indeterminate?: boolean;
  semantic?: boolean;
  testId?: string;
}) {
  return (
    <Flex
      align="center"
      gap="3xl"
      justify="space-between"
      px="2xl"
      py="xl"
      w="full"
    >
      <Flex className={classNames(disabled && css.rowLabelDisabled)}>
        <SettingsRowLabel
          badge={badge}
          description={description}
          title={title}
        />
      </Flex>
      <RedoToggle
        aria-label={title}
        disabled={disabled}
        indeterminate={indeterminate}
        semantic={semantic}
        setValue={setValue}
        size="sm"
        testId={testId}
        value={value}
      />
    </Flex>
  );
});
